import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from "@mui/material";
import MuiDrawer from '@mui/material/Drawer';
import InputBase from '@mui/material/InputBase';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import { styled } from '@mui/material/styles';
import { Layout, Menu, theme } from 'antd';
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Persistor } from "../..";
import { NavContext } from "../../App";
import New from "../../Pages/SAV/AddTicket/NewSAVTicket";
import ListAllTickets from "../../Pages/SAV/TicketList/ListAllTickets/ListAllTickets";
import { addTab, setLastActiveTab } from "../../ReduxTLK/features/Tabs/TabsSlice";
import routes from '../../routes';
import SAVIcon from "../IconComponents/SAVIcon";
import SidebarFooter from "./SidebarFooter";
import './Sidebar.css';

// Import new icons from Material-UI
import TicketIcon from '@mui/icons-material/ConfirmationNumber';
import AddIcon from '@mui/icons-material/Add';
import ListIcon from '@mui/icons-material/List';


const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(

  ({ theme, open, drawerwidth, height }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerwidth,
      marginBottom: 10,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),

        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'white',
  borderRadius: '20px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  alignSelf: 'stretch',
  border: '1px solid var(--Light-Gray, #F1F1F1)',
  background: 'var(--White, #FFF)',
  marginRight: theme.spacing(2),
  marginleft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginleft: theme.spacing(3),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '90%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const CustomIconSAV = () => {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', marginTop: 0,
    }}>
      <SAVIcon style={{ marginRight: 10 }} />
      <span style={{ marginLeft: 27, fontWeight: '600', fontSize: '14px' }}>Support SAV</span>
    </div>
  )
}

const CustomIconTousLesTickets = () => {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', marginTop: 0,
    }}>
      <ListIcon style={{ marginRight: 10, color: '#357BCD' }} />
      <span style={{ marginLeft: 27, fontWeight: '600', fontSize: '14px' }}>Tous Les Tickets</span>
    </div>
  )
}

const CustomIconAjoutTicket = () => {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', marginTop: 0,
    }}>
      <AddIcon style={{ marginRight: 10, color: '#027A48' }} />
      <span style={{ marginLeft: 27, fontWeight: '600', fontSize: '14px' }}>Ajout Ticket</span>
    </div>
  )
}

const { Sider, Footer } = Layout;
export function useWindowDimensions() {

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export default function Sidebar({ toggleDrawer, drawerwidth, open, sidebarMinimize, sidebarMaximize, miniActive, mode }) {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const { height, width } = useWindowDimensions();
  const drawerFooterHeight = (height / 100) * 7;
  const sideBarWidth = (width / 100) * 16;
  const context = useContext(NavContext)
  const dispatch = useDispatch()
  const [openCollapse, setOpenCollapse] = React.useState(false);


  const { SubMenu } = Menu;
  function openNewTabTT(props) {


    // Find any existing tab with the same ID
    const existingTabIndex = context.tabs.findIndex((tab) => tab.id === 3);

    // If a tab with the ID already exists, activate it
    if (existingTabIndex !== -1) {
      context.setActiveTab(3);
      dispatch(setLastActiveTab(3));
      return; // Exit the function to avoid creating a duplicate tab
    }

    // If no existing tab found, create a new one
    dispatch(addTab({
      module: 'SAV',
      action: 'Tous les tickets',
      identifier: 3,
      id: 3,
      label: 'Tous les tickets',
    }));

    context.setTabs([...context.tabs, {
      id: 3,
      label: 'Tous les tickets',
      identifier: 3,
      component: <ListAllTickets />,
      closeable: true,
      icon: <TicketIcon />,
    }]);
    Persistor.persist();
    context.setActiveTab(3);
    dispatch(setLastActiveTab(3));
  }
  function openNewTabAT(props) {


    // Find any existing tab with the same ID
    const existingTabIndex = context.tabs.findIndex((tab) => tab.id === 2);

    // If a tab with the ID already exists, activate it
    if (existingTabIndex !== -1) {
      context.setActiveTab(2);
      dispatch(setLastActiveTab(2));
      return; // Exit the function to avoid creating a duplicate tab
    }

    // If no existing tab found, create a new one
    dispatch(addTab({
      module: 'SAV',
      action: 'Ajout Ticket',
      identifier: 2,
      id: 2,
      label: 'Ajout Ticket',
    }));

    context.setTabs([...context.tabs, {
      id: 2,
      label: 'Ajout Ticket',
      identifier: 2,
      component: <New />,
      closeable: true,
      icon: <AddIcon />,
    }]);
    Persistor.persist();
    context.setActiveTab(2);
    dispatch(setLastActiveTab(2));
  }
  const handleClick = () => {
    setOpenCollapse(!openCollapse);
  };

  const [searchInput, setSearchInput] = useState('');
  const [Routes, setRoutes] = useState([]);
  const [filtredMenu, setFiltredMenu] = useState([]);

  useEffect(() => {

    if (routes[0].pages.length > 0) {
      setRoutes(routes[0].pages);
      setFiltredMenu(routes[0].pages);
    }

  }, []);


  function handleSearchMenu(e) {
    var lowerCase = e.target.value.toLowerCase();
    setSearchInput(lowerCase);
    const filtredMenu = Routes.filter((item) => {
      if (searchInput === '') {

        return item;

      }
      else {

        return item.name.toLowerCase().includes(searchInput)
      }
    }
    )
    setFiltredMenu(filtredMenu);


  }

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {

    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <div className="sidebar-main-container">
        <Drawer
          variant="permanent"
          open={open}
          drawerwidth={drawerwidth}
        >
          <div className="drawer-content-wrapper">
            <List
              sx={{
                width: '100%',
                maxWidth: 360,
                bgcolor: 'white'
              }}
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <ListSubheader component="div" id="nested-list-subheader">
                  {open ? (
                    <Search>
                      <SearchIconWrapper>
                        <SearchIcon className="search-icon-color" />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        value={searchInput}
                        onChange={handleSearchMenu}
                      />
                    </Search>
                  ) : (
                    <IconButton
                      component="div"
                      className="icon-button-color"
                    >
                      <SearchIcon />
                    </IconButton>
                  )}
                </ListSubheader>
              }
            >
              <Layout
                className="layout-container"
                style={{
                  borderRadius: borderRadiusLG,
                }}
              >
                <Sider
                  className={mode === 'inline' ? 'sider-inline' : 'sider-collapsed'}
                  style={{
                    background: colorBgContainer,
                  }}
                >
                  <Menu
                    mode={mode}
                    className="sidebar-menu"
                  >
                    <Menu.Item key="1" onClick={() => openNewTabTT()}>
                      <CustomIconTousLesTickets />
                    </Menu.Item>
                    <Menu.Item key="2" onClick={() => openNewTabAT()}>
                      <CustomIconAjoutTicket />
                    </Menu.Item>
                  </Menu>
                </Sider>
              </Layout>
            </List>
          </div>

          <footer className="footer-container">
            <SidebarFooter
              open={open}
              mode={mode}
              sidebarMinimize={sidebarMinimize}
              sidebarMaximize={sidebarMaximize}
              miniActive={miniActive}
            />
          </footer>
        </Drawer>
      </div>
    </>
  );
}